import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { ButtonTypes } from '@app/shared/enums/buttonTypes.enum';

@Component({
  selector: 'app-register-button',
  templateUrl: './register-button.component.html'
})
export class RegisterButtonComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
  }

  registerLink:string = 'https://buytickets.at/iowacodecamp/1300554';
}
